import { getStatisticsFromOrigin } from "../helpers/requestHandler";

let data = [];

const instanceParse = (notices) => {
    let instances = []

    if (notices) {
        notices.forEach(instance => {
            instances.push(JSON.parse(instance.data))
        })
        
        const combinedData = instances.reduce((result, obj) => {
            const { instance, data } = obj;
            const existingIndex = result.findIndex(item => item.instance === instance);
        
            if (existingIndex === -1) {
            result.push(obj);
            } else {
            // Instance already exists, add workflow counts together
            result[existingIndex].data.forEach((workflow, index) => {
                workflow.count += data[index].count;
            });
            }
        
            return result;
        }, []);
        return combinedData;
    }
}

// This needs to be handled on backend

const dataSource = async () => {
    
    let notices = await getStatisticsFromOrigin(`${global.config.backend.baseURI}/api/Statistic/GetCommunicatedNoticesByInstanceRange`, global.config.dashboard.range)
    let instances = instanceParse(notices); 

    if (instances) {
        let data = [];
        instances.forEach(instance => {
            if ( !( instance.instance in data ) ) {
                let val = instance.data.reduce((sum, { count }) => sum + count, 0)
                instance.data.forEach(notice => {
                    data.push({arg: notice.workflow, val: notice.count, parentID: instance.instance})
                })
                data.push({arg: instance.instance, val: val, parentID: ''})
            }
        })
        return data;
    }
}

// eslint-disable-next-line
export default {
    async filterData(name) {
        
        let resp;
        let range;

        // This is when the range has been changed, tells the api to update data.
        if(range !== global.config.dashboard.range) {
            resp = await dataSource();
            range = global.config.dashboard.range
        } else {

            /*
            // If the data array already exists then we set the response as the existing data 
            // This is used for workflows grabbing parent data and when click the return button.
            */
            if(data.length > 5) {
                resp = data;
             }  else {
                resp = await dataSource();
            }
        }

        if (resp) {
            return resp.filter((item) => item.parentID === name);
        }

        return null;
    },
};